
        import Symbol from "../../../svg-baker-runtime/browser-symbol.js";
        import sprite from "../../../svg-sprite-loader/runtime/browser-sprite.build.js";

        const symbol = new Symbol({
  "id": "icon-material-layers",
  "use": "icon-material-layers-usage",
  "viewBox": "0 -960 960 960",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 -960 960 960\" id=\"icon-material-layers\"><path d=\"m479.76-113.98-369.8-287.89 56.69-42.02 313.11 243.63 313.59-243.63 56.69 42.02zm0-162.28-369.8-287.65 369.8-287.89L849.8-563.91zm0-86.52 258.41-201.13-258.41-201.13-258.41 201.13z\" /></symbol>"
});
        sprite.add(symbol);

        function Icon({...props}) {
            return (
                <svg {...props} className="icon" fill="currentColor">
                    <use xlinkHref="#icon-material-layers"/>
                </svg>
            );
        };

        Icon.id = "icon-material-layers";

        export default Icon;
    